import { $, $$, onReady, isMobile } from '../nth-ms26-core/js/env';

/*
 * Bộ chọn môn phái tự dựng từ danh sách .class-item (khách chỉ sửa assets/static/frame3.html.twig).
 * PC: tên xếp theo cung cong như PSD (8 tên từ y=247 → 679), ít phái hơn thì cụm tên tự canh giữa cung.
 * MB: dãy chấm + vuốt ngang. Thêm/bớt phái chỉ cần thêm/bớt <li class="class-item">.
 * Ảnh chỉ tải cho phái đang xem; phái kế bên tải trước khi rảnh / khi rê chuột vào tên.
 */
const ARC = { top: 247, bottom: 679, step: 62, peakX: 1462, peakY: 380, bend: 0.000771 };

onReady(() => {
  const root = $('[data-classes]');
  if (!root) return;
  const items = $$('.class-item', root);
  const picker = $('[data-classes-picker]', root);
  if (!items.length || !picker) return;
  const mobile = isMobile();
  const imgSel = mobile ? '.class-item__char, .class-item__title' : '.class-item__art, .class-item__title';
  let current = -1; // phái đang hiển thị
  let selected = -1; // phái vừa bấm (có thể đang chờ ảnh)

  const warm = (i) => {
    if (!items[i]) return;
    $$(imgSel, items[i]).forEach((img) => { img.loading = 'eager'; });
  };

  const step = items.length > 1 ? Math.min(ARC.step, (ARC.bottom - ARC.top) / (items.length - 1)) : 0;
  const top = (ARC.top + ARC.bottom) / 2 - (step * (items.length - 1)) / 2;
  const buttons = items.map((item, i) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'class-pick';
    btn.setAttribute('aria-pressed', 'false');
    const label = document.createElement('span');
    label.textContent = ($('.class-item__name', item) || item).textContent.trim();
    btn.appendChild(label);
    item.setAttribute('aria-hidden', 'true');
    item.inert = true;
    btn.addEventListener('click', () => show(i));
    btn.addEventListener('pointerenter', () => warm(i));
    btn.addEventListener('focus', () => warm(i));
    if (!mobile) {
      const y = top + i * step;
      const x = ARC.peakX - ARC.bend * (y - ARC.peakY) ** 2;
      btn.style.left = `${Math.round(x)}px`;
      btn.style.top = `${Math.round(y)}px`;
    }
    picker.appendChild(btn);
    return btn;
  });

  // Ảnh JPEG đang tải dở mà đã hiện thì Chrome tô phần chưa về bằng nền đặc → khung trắng loé đè lên phái cũ.
  // Nên chỉ bắt đầu mờ dần khi ảnh phái mới đã tải + giải mã xong (tối đa 5s rồi hiện luôn).
  const imgReady = (img) => {
    const decode = () => (img.decode ? img.decode().catch(() => {}) : null);
    if (img.complete && img.naturalWidth) return decode();
    return new Promise((res) => {
      img.addEventListener('load', res, { once: true });
      img.addEventListener('error', res, { once: true });
    }).then(decode);
  };
  const itemReady = (i) => Promise.race([
    Promise.all($$(imgSel, items[i]).map(imgReady)),
    new Promise((res) => setTimeout(res, 5000)),
  ]);
  let pending = 0;

  function show(i, instant = false) {
    if (i === selected || !items[i]) return;
    selected = i;
    // đổi trạng thái nút chọn ngay để phản hồi tức thì, cảnh đổi khi ảnh sẵn sàng
    buttons.forEach((b, k) => {
      b.classList.toggle('is-active', k === i);
      b.setAttribute('aria-pressed', String(k === i));
    });
    warm(i);
    if (instant) {
      swap(i, true);
      return;
    }
    const token = ++pending;
    root.classList.add('is-loading');
    itemReady(i).then(() => {
      if (token !== pending) return; // người dùng đã bấm phái khác trong lúc chờ
      root.classList.remove('is-loading');
      swap(i, false);
    });
  }

  // Phái cũ mờ dần (CSS leave-fade) rồi mới gỡ ở animationend — timer chỉ dự phòng (reduced-motion: không có animation).
  // MB: bỏ vết mực (mask phóng to cả khung 768×1662 nặng GPU điện thoại) → chỉ mờ dần 0.3s.
  const LEAVE_MS = mobile ? 700 : 2300;
  const leaveTimers = new Map();

  function swap(i, instant) {
    if (i === current) return;
    const prev = items[current];
    const next = items[i];
    clearTimeout(leaveTimers.get(next)); // bấm quay lại phái vừa rời khi nó còn đang mờ
    next.classList.remove('is-leaving', 'is-fading');
    next.classList.add('is-shown');
    next.classList.toggle('is-revealing', !instant && !mobile);
    next.inert = false;
    next.setAttribute('aria-hidden', 'false');
    if (prev) {
      prev.classList.remove('is-active', 'is-shown', 'is-revealing');
      prev.classList.add('is-leaving');
      prev.inert = true;
      prev.setAttribute('aria-hidden', 'true');
      leaveTimers.set(prev, setTimeout(() => prev.classList.remove('is-leaving', 'is-fading'), LEAVE_MS));
    }
    const activate = () => next.classList.add('is-active');
    if (instant) activate();
    else requestAnimationFrame(() => requestAnimationFrame(activate));
    current = i;
    // tải trước phái kế bên SAU khi loang xong: mask-size vẽ lại trên luồng chính, decode ảnh lúc đó dễ rớt khung
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 600));
    setTimeout(() => idle(() => { warm(i + 1); warm(i - 1); }), instant ? 0 : 1400);
  }

  // vào tới màn Môn phái → tải trước ảnh mọi phái lúc rảnh, bấm phái nào cũng hiện ngay
  const warmAll = () => {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 800));
    idle(() => items.forEach((_, k) => warm(k)));
  };
  const frame = root.closest('[data-frame]');
  if (mobile && frame && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      warmAll();
    }, { rootMargin: '50% 0px' });
    io.observe(frame);
  } else if (frame) {
    const onFrame = (e) => {
      if (e.detail.frame !== frame) return;
      document.removeEventListener('nth:frame', onFrame);
      warmAll();
    };
    document.addEventListener('nth:frame', onFrame);
  }

  const move = (dir) => {
    const k = selected + dir;
    if (k >= 0 && k < items.length) show(k);
  };

  picker.addEventListener('keydown', (e) => {
    const map = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
    if (!(e.key in map)) return;
    e.preventDefault();
    e.stopPropagation(); // không để fullpage hiểu nhầm là chuyển màn
    move(map[e.key]);
    buttons[selected].focus();
  });

  // điện thoại: vuốt ngang trên hình nhân vật để đổi phái
  if (mobile) {
    let x0 = null;
    let y0 = null;
    const list = $('.classes__list', root);
    list.addEventListener('touchstart', (e) => {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    list.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  items.forEach((it) => it.addEventListener('animationend', (e) => {
    if (e.target !== it) return;
    if (e.animationName === 'ink-reveal') {
      it.classList.remove('is-revealing');
      // mực đã phủ kín → giờ mới cho các phái đang rời mờ dần (kể cả khi bấm liên tiếp nhiều phái)
      items.forEach((o) => { if (o !== it && o.classList.contains('is-leaving')) o.classList.add('is-fading'); });
    }
    // phái cũ đã mờ hẳn → mới tắt display (tắt sớm hơn là vùng sương/trong suốt của phái mới đổi "rụp")
    if (e.animationName === 'leave-fade') {
      clearTimeout(leaveTimers.get(it));
      it.classList.remove('is-leaving', 'is-fading');
    }
  }));

  const start = items.findIndex((it) => it.hasAttribute('data-active'));
  show(Math.max(start, 0), true);
});
